import React from 'react';
import { Tooltip, Typography, Box } from '@mui/material';

import icon_snmp from 'assets/images/icons/icn_Info_solid.svg';
import icon_snmp_hover from 'assets/images/icons/icn_info_solid_hover.svg';

export default function CustomTooltip() {
  return (
    <Tooltip
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 850,
            backgroundColor: '#4D4D4D',
          },
        },
      }}
      title={
        <Box>
          <Typography fontWeight="bold" fontSize={13}>{`Good — Mean RSSI ≥ -65 dBm / Weak Client < 5%`}</Typography>
          <Typography variant="body2" fontSize={13}>
            Signal quality is excellent. Most clients maintain strong connections.
          </Typography>

          <Typography fontWeight="bold" fontSize={13} sx={{ mt: 2 }}>
            {`Warning — -75 dBm ≤ Mean RSSI < -65 dBm / 5% ≤ Weak Client ≤ 15%`}
          </Typography>
          <Typography variant="body2" fontSize={13}>
            Some clients are experiencing weak signals, which may cause lower throughput or unstable connectivity in certain areas.
          </Typography>
          <Typography fontWeight="bold" fontSize={13}>
            Recommended Actions:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 16, fontSize: 13 }}>
            <li>Identify and resolve sticky client issues.</li>
          </ul>

          <Typography fontWeight="bold" fontSize={13} sx={{ mt: 2 }}>
            {`Critical — Mean RSSI < -75 dBm / Weak Client > 15%`}
          </Typography>
          <Typography variant="body2" fontSize={13}>
            Severe signal degradation is affecting user experience, causing poor performance and frequent connection issues.
          </Typography>
          <Typography fontWeight="bold" fontSize={13}>
            Recommended Actions:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 16, fontSize: 13 }}>
            <li>Fine-tune Access Point transmit power.</li>
            <li>Add Access Points to improve coverage and capacity.</li>
          </ul>
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 16,
          '& img': {
            content: `url(${icon_snmp})`,
          },
          '&:hover img': {
            content: `url(${icon_snmp_hover})`,
          },
        }}
      >
        <img src={icon_snmp} alt="" style={{ width: 16, height: 16, cursor: 'pointer' }} />
      </Box>
    </Tooltip>
  );
}
